import Vue from 'vue';

Vue.component('monitor-index', () =>
    import(/* webpackChunkName: 'monitor-index' */ './monitor-index.vue'),
);
